import { iconSizeOptions } from '../../atoms/icons/icons-sizes'
import { RoleAdministrator } from '../../atoms/icons/users'
import BadgesComponent from '../../atoms/badges'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgesVariantOptions
} from '../../atoms/badges/constants'
import { Download } from '../../atoms/icons/core'

export const dropdownBoxStyleOptions = {
  MINIMAL: 'minimal',
  BOX: 'box'
}

export const dropdownHeaderOptions = {
  SECTION: 'section',
  TABS: 'tabs',
  SEARCH: 'search',
  DEFAULT: 'default'
}

// MOCK DUMMY'S
export const DUMMY_ITEMS_SIMPLE = [
  {
    id: '1',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Administrator'
  },
  {
    id: '2',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Member'
  },
  {
    id: '3',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Contributor'
  },
  {
    id: '4',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Owner'
  }
]

export const DUMMY_ITEMS_FULL = [
  {
    id: '5',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Administrator',
    secondaryText: 'Detailed roledescription pointing out privileges',
    divider: true,
    chevron: true,

    badge: (
      <BadgesComponent
        color={badgeColorOptions.DOCU_TOOLS_ORANGE}
        variant={badgesVariantOptions.STRONG}
        size={badgeSizeOptions.SMALL}
      >
        Multi
      </BadgesComponent>
    ),

    trailingIcon: <Download />
  },
  {
    id: '6',
    leadingIcon: <RoleAdministrator size={iconSizeOptions['ICON-M']} />,
    title: 'Member',
    secondaryText: 'Detailed roledescription pointing out privileges',
    divider: true,
    chevron: true,

    badge: (
      <BadgesComponent
        color={badgeColorOptions.DOCU_TOOLS_ORANGE}
        variant={badgesVariantOptions.STRONG}
        size={badgeSizeOptions.SMALL}
      >
        Multi
      </BadgesComponent>
    ),

    trailingIcon: <Download />
  }
]
